import React from 'react';
import ReactDOM from 'react-dom';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider'
import injectTapEventPlugin from 'react-tap-event-plugin'
import { Router, Route, hashHistory } from 'react-router'
import DocList from './components/DocList.js'
import DocDetail from './components/DocDetail.js'
import './rwdLimit.css'

try{
  injectTapEventPlugin()
}catch(err){

}

const App2 = () => (
  <MuiThemeProvider>
	  <Router history={hashHistory}>
	    <Route path="/" component={DocList}/>
	    <Route path="detail" component={DocDetail}/>
	  </Router>
  </MuiThemeProvider>
);


ReactDOM.render(
  <App2 />,
  document.getElementById('root')
);



// WEBPACK FOOTER //
// ./src/index.js